import React, { createContext, useState, useCallback } from "react";
import Toast from "../components/toast/toast.component";

export const ToastContext = createContext();

const AUTO_CLOSE_TIME = 4000;

function ToastContextProvider({ children }) {
  const [showToast, setShowToast] = useState(false);
  const [success, setSuccess] = useState(true);
  const [message, setMessage] = useState("");

  function delay(t, val) {
    return new Promise((resolve) => setTimeout(resolve, t, val));
  }

  const displayToast = useCallback(({ success, message, finishedCallback }) => {
    setSuccess(success);
    setMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), AUTO_CLOSE_TIME + 100);
    if (typeof finishedCallback !== "function") return;
    return delay(4100).then(() => finishedCallback());
  }, []);

  return (
    <ToastContext.Provider value={displayToast}>
      {children}
      <Toast
        showToast={showToast}
        success={success}
        message={message}
        autoCloseTime={AUTO_CLOSE_TIME}
      />
    </ToastContext.Provider>
  );
}

export default ToastContextProvider;
